import Configurator from "../../config/Configurator";
import axios from "axios";
import store from "../../services/store";
import notify from "../../utils/Notification/notify";
/**
 * Sends either a single or multiple commands.
 *
 * @param {Object|any} command - For isMulti = false, the actual command value (number or string). For isMulti = true, an object of writeTag: commandValue.
 * @param {string|null} requestNumber - Required for single command; ignored for multi.
 * @param {string} ship - Target ship name.
 * @param {boolean} isMulti - Whether this is a multi-command send.
 */
export const sendCommand = async (
  command,
  requestNumber,
  ship,
  isMulti = false
) => {
  let storeState = store.getState();
  let isPlaybackMode = storeState.appConfig.isPlaybackMode;

  if (isPlaybackMode) {
    const err = new Error("Playback mode: command blocked");
    err.code = "PLAYBACK_MODE";
    throw err;
  }

  const d = {
    data: {},
    metadata: {},
  };

  if (isMulti) {
    d.data.records = command;
  } else {
    d.data.records = {
      [requestNumber]: command,
    };
  }

  d.data.msExpiration = 1000;

  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: (await Configurator()).API_URL + "/v2/io/commands/set/" + ship,
    headers: {
      ...axios.defaults.headers.common,
      Session: localStorage.getItem("apiKey"),
      "User-Id": localStorage.getItem("userID"),
    },
    data: JSON.stringify(d),
  };

  return axios.request(config);
};
